<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="simple-validation">
            <div class="card" style="padding: 20px">
                <div class="row">
                    <div class="col-12 mt-1 mb-1">
                        <h4 class="text-uppercase">Edit Player</h4>
                        <p>Edit Player in the system</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card-body">
                            <form class="form-horizontal" [formGroup]="playerForm">
                                <div class="section border p-3 mb-3">
                                    <h5 class="text-uppercase mb-3 card-title font-weight-">Personal Information</h5>
                                    <div class="row">
                                        <div class="col-sm-4 d-flex align-items-center">
                                            <img [src]="playerImage" alt="Player Image" class="avatar"
                                                style="width: 150px; height: 150px ; object-fit: cover;" />
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="playerImage">Please select image</label>
                                                <div class="custom-file">
                                                    <input type="file" accept="image/*" class="custom-file-input"
                                                        (change)="onFileSelected($event)" id="playerImage"
                                                        name="playerImage" />
                                                    <label class="custom-file-label" for="playerImage">Choose
                                                        file</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section border p-3">

                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label for="firstName">First Name</label>
                                                    <input class="form-control" formControlName="firstName"
                                                        name="firstName" required id="firstName" type="text"
                                                        placeholder="Enter first name..." />
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label for="lastName">Last Name</label>
                                                    <input class="form-control" formControlName="lastName"
                                                        name="lastName" required id="lastName" type="text"
                                                        placeholder="Enter last name..." />
                                                </div>
                                            </div>

                                            <!-- GENDER SECTION -->
                                            <!-- Status  -->
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label for="gender">Gender</label>
                                                    <div class="btn-group btn-group-toggle d-flex"
                                                        data-toggle="buttons">
                                                        <label class="btn btn-outline-secondary"
                                                            [class.active]="playerForm.controls['gender'].value === 'MALE'">
                                                            <input type="radio" name="gender" formControlName="gender"
                                                                value="MALE" autocomplete="off" /> Male
                                                        </label>
                                                        <label class="btn btn-outline-secondary"
                                                            [class.active]="playerForm.controls['gender'].value === 'FEMALE'">
                                                            <input type="radio" name="gender" formControlName="gender"
                                                                value="FEMALE" autocomplete="off" /> Female
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>



                                            <!-- Nationality -->
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label for="nationalityId">Nationality</label>
                                                    <select class="form-control" formControlName="nationalityId"
                                                        id="nationalityId" required>
                                                        <option *ngFor="let nationality of nationalities"
                                                            [value]="nationality.id">
                                                            {{ nationality.nationality }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!-- Country -->
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label for="countryId">Country</label>
                                                    <select class="form-control" formControlName="countryId"
                                                        id="countryId" required>
                                                        <option *ngFor="let country of countries" [value]="country.id">
                                                            {{ country.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <!-- City -->

                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <label for="city">City</label>
                                                    <input class="form-control" formControlName="city" name="city"
                                                        required id="city" type="text" placeholder="Enter city..." />
                                                </div>
                                            </div>

                                            <!-- BIO SECTION -->
                                            <div class="col-sm-12 col-12">
                                                <div class="form-group">
                                                    <label for="bio">Bio</label>
                                                    <textarea class="form-control" formControlName="bio" name="bio"
                                                        id="bio" placeholder="Enter bio..." rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end align-items-center">
                                        <button type="button" class="btn btnn mt-2" (click)="updatePlayer()">
                                            Save Changes
                                        </button>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-sm-4">
                                            <label>Weight (kg)</label>
                                            <input type="text" class="form-control" [value]="playerForm.value.weight"
                                                readonly>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>Height (cm)</label>
                                            <input type="text" class="form-control" [value]="playerForm.value.height"
                                                readonly>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>Strong Foot</label>
                                            <input type="text" class="form-control"
                                                [value]="playerForm.value.strongFoot" readonly>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>Primary Position</label>
                                            <input type="text" class="form-control"
                                                [value]="playerForm.value.primaryPosition" readonly>
                                        </div>
                                        <div class="col-sm-4">
                                            <label>Other Position</label>
                                            <input type="text" class="form-control"
                                                [value]="playerForm.value.otherPosition" readonly>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>